import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastService } from '@shared/services/toast.service';
import { EMPTY, Observable, forkJoin } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AirportModel, HandlerInfoModel } from '../models/airport.model';

export interface AirportBriefing {
  airport: AirportModel;
  handlerList: HandlerInfoModel[];
}

export abstract class AirportBriefingPort {
  abstract getAirport(id: string): Observable<AirportModel>;
  abstract getHandlerList(id: string): Observable<HandlerInfoModel[]>;
}

@Injectable()
export class AirportBriefingLoader {
  private port = inject(AirportBriefingPort);
  private platformId = inject(PLATFORM_ID);
  private title = inject(Title);
  private message = inject(ToastService);

  load(id: string): Observable<AirportBriefing> {
    return forkJoin({
      airport: this.port.getAirport(id),
      handlerList: this.port.getHandlerList(id),
    }).pipe(
      tap(({ airport }) => {
        if (isPlatformBrowser(this.platformId)) {
          this.title.setTitle(`EVO Apps | ${airport.icao} briefing`);
        }
      }),
      catchError((error) => {
        if (error.status === 403) {
          this.message.error('Access denied. You do not have permission to view this airport.');
        } else {
          this.message.error('An error occurred while loading airport data.');
        }
        return EMPTY;
      }),
    );
  }
}
